import * as React from 'react'

export const StageDaily = props => (
  <svg
    width={72}
    height={80}
    viewBox="0 0 72 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12630)">
      <path
        d="M33.0674 8.03856C34.8165 7.01291 36.9835 7.01291 38.7326 8.03856L60.8454 21.0049C62.5597 22.0101 63.6128 23.8484 63.6128 25.8356V51.9195C63.6128 53.9068 62.5597 55.7451 60.8454 56.7503L38.7326 69.7166C36.9835 70.7423 34.8165 70.7423 33.0674 69.7166L10.9546 56.7503C9.24032 55.7451 8.18718 53.9068 8.18718 51.9195V25.8356C8.18718 23.8484 9.24032 22.0101 10.9546 21.0049L33.0674 8.03856Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.0902 14.9968C34.8278 13.9888 36.9722 13.9888 38.7099 14.9968L55.4006 24.6785C57.1277 25.6803 58.1908 27.5259 58.1908 29.5225V48.9316C58.1908 50.9282 57.1277 52.7738 55.4006 53.7756L38.7099 63.4574C36.9722 64.4653 34.8278 64.4653 33.0902 63.4574L16.3994 53.7756C14.6723 52.7738 13.6093 50.9282 13.6093 48.9316V29.5225C13.6093 27.5259 14.6723 25.6803 16.3994 24.6785L33.0902 14.9968Z"
        fill="#61BA79"
      />
      <path
        d="M51.9 28.9588C51.9 26.1377 49.613 23.8507 46.7919 23.8507H25.0081C22.187 23.8507 19.9 26.1377 19.9 28.9588V39.2271V46.9152V49.4953C19.9 52.3164 22.187 54.6034 25.0081 54.6034H46.7919C49.613 54.6034 51.9 52.3164 51.9 49.4953V46.9152V39.2271V28.9588Z"
        fill="#FFFAC7"
      />
      <path
        d="M36.3023 54.6034H35.4977V23.8507H36.3023V54.6034Z"
        fill="#C2A085"
      />
      <path
        d="M27.4512 44.5389C27.7475 44.5389 27.9877 44.7892 27.9877 45.098V45.9367C27.9877 46.2455 27.7475 46.4959 27.4512 46.4959H23.1598C22.8635 46.4959 22.6234 46.2455 22.6234 45.9367V45.098C22.6234 44.7892 22.8635 44.5389 23.1598 44.5389H27.4512Z"
        fill="#C2A085"
      />
      <path
        d="M31.2062 44.5389C31.5025 44.5389 31.7427 44.7892 31.7427 45.098V45.9367C31.7427 46.2455 31.5025 46.4959 31.2062 46.4959H29.5969C29.3007 46.4959 29.0605 46.2455 29.0605 45.9367V45.098C29.0605 44.7892 29.3007 44.5389 29.5969 44.5389H31.2062Z"
        fill="#C2A085"
      />
      <path
        d="M42.203 44.5389C42.4993 44.5389 42.7394 44.7892 42.7394 45.098V45.9367C42.7394 46.2455 42.4993 46.4959 42.203 46.4959H40.5937C40.2975 46.4959 40.0573 46.2455 40.0573 45.9367V45.098C40.0573 44.7892 40.2975 44.5389 40.5937 44.5389H42.203Z"
        fill="#C2A085"
      />
      <path
        d="M48.6401 44.5389C48.9364 44.5389 49.1766 44.7892 49.1766 45.098V45.9367C49.1766 46.2455 48.9364 46.4959 48.6401 46.4959H44.3487C44.0525 46.4959 43.8123 46.2455 43.8123 45.9367V45.098C43.8123 44.7892 44.0525 44.5389 44.3487 44.5389H48.6401Z"
        fill="#C2A085"
      />
      <path
        d="M31.2062 39.5066C31.5025 39.5066 31.7427 39.757 31.7427 40.0658V40.9045C31.7427 41.2133 31.5025 41.4636 31.2062 41.4636H23.1598C22.8635 41.4636 22.6234 41.2133 22.6234 40.9045V40.0658C22.6234 39.757 22.8635 39.5066 23.1598 39.5066H31.2062Z"
        fill="#C2A085"
      />
      <path
        d="M44.8852 39.5066C45.1814 39.5066 45.4216 39.757 45.4216 40.0658V40.9045C45.4216 41.2133 45.1814 41.4636 44.8852 41.4636H40.5937C40.2975 41.4636 40.0573 41.2133 40.0573 40.9045V40.0658C40.0573 39.757 40.2975 39.5066 40.5937 39.5066H44.8852Z"
        fill="#C2A085"
      />
      <path
        d="M48.6401 39.5066C48.9364 39.5066 49.1766 39.757 49.1766 40.0658V40.9045C49.1766 41.2133 48.9364 41.4636 48.6401 41.4636H47.0309C46.7346 41.4636 46.4944 41.2133 46.4944 40.9045V40.0658C46.4944 39.757 46.7346 39.5066 47.0309 39.5066H48.6401Z"
        fill="#C2A085"
      />
      <path
        d="M24.7691 34.4744C25.0654 34.4744 25.3055 34.7247 25.3055 35.0335V35.8722C25.3055 36.181 25.0654 36.4314 24.7691 36.4314H23.1598C22.8635 36.4314 22.6234 36.181 22.6234 35.8722V35.0335C22.6234 34.7247 22.8635 34.4744 23.1598 34.4744H24.7691Z"
        fill="#C2A085"
      />
      <path
        d="M31.2062 34.4744C31.5025 34.4744 31.7427 34.7247 31.7427 35.0335V35.8722C31.7427 36.181 31.5025 36.4314 31.2062 36.4314H26.9148C26.6185 36.4314 26.3784 36.181 26.3784 35.8722V35.0335C26.3784 34.7247 26.6185 34.4744 26.9148 34.4744H31.2062Z"
        fill="#C2A085"
      />
      <path
        d="M48.6401 34.4744C48.9364 34.4744 49.1766 34.7247 49.1766 35.0335V35.8722C49.1766 36.181 48.9364 36.4314 48.6401 36.4314H40.5937C40.2975 36.4314 40.0573 36.181 40.0573 35.8722V35.0335C40.0573 34.7247 40.2975 34.4744 40.5937 34.4744H48.6401Z"
        fill="#C2A085"
      />
      <path
        d="M48.6401 29.4421C48.9364 29.4421 49.1766 29.6924 49.1766 30.0012V30.84C49.1766 31.1488 48.9364 31.3991 48.6401 31.3991H40.5937C40.2975 31.3991 40.0573 31.1488 40.0573 30.84V30.0012C40.0573 29.6924 40.2975 29.4421 40.5937 29.4421H48.6401Z"
        fill="#C2A085"
      />
      <g filter="url(#filter1_d_81_12630)">
        <path
          d="M27.9048 30.8878C27.9048 31.3018 27.3473 31.4344 27.161 31.0646L25.8544 28.4711C25.7092 28.1829 25.2978 28.1829 25.1526 28.4711L23.846 31.0646C23.6597 31.4344 23.1021 31.3018 23.1021 30.8878V24.2436C23.1021 24.0266 23.278 23.8507 23.495 23.8507H27.5119C27.7289 23.8507 27.9048 24.0266 27.9048 24.2436V30.8878Z"
          fill="#DB5A5F"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_81_12630"
        x="-4.10001"
        y="-0.622406"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12630"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12630"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_81_12630"
        x="23.1021"
        y="23.8507"
        width="4.80273"
        height="8.60946"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.1788" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12630"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12630"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
